<template>
	<div :class="['my-menu', mode === 'horizontal' ? 'horizontal' : 'vertical']">
		<div
			v-for="item in routeList"
			@click="switchPage(item.name)"
			:key="item.name"
			:class="item.name == activedRoute ? 'actived' : ''"
		>
			{{ item.text }}
		</div>
	</div>
</template>
<script>
import Bus from './bus.js'
export default {
	name: 'MyMenu',
	props: {
		mode: {
			type: String,
			default: 'horizontal',
		},
	},
	data() {
		return {
			routeList: [
				{
					name: 'home',
					text: '首页',
				},
				{
					name: 'products',
					text: '产品目录',
				},
				{
					name: 'product',
					text: '产品介绍',
				},
				{
					name: 'productCertificate',
					text: '产品证书',
				},
				{
					name: 'Certificate',
					text: '授权证书',
				},
			],
			activedRoute: 'home',
		}
	},
	mounted() {
		let savedNav = localStorage.getItem('activeNav')
		if (savedNav) {
			this.activedRoute = savedNav
		}
	},
	methods: {
		switchPage(param) {
			if (this.activedRoute == param) {
				return
			}
			localStorage.setItem('activeNav', param)
			this.activedRoute = param
			Bus.$emit('changePage', param)
		},
	},
}
</script>
<style lang="scss">
.my-menu {
	box-sizing: border-box;
	display: flex;
	padding-right: 12px;
	align-items: center;

	&.horizontal {
		flex-direction: row;
	}

	&.vertical {
		flex-direction: column;
		padding-left: 12px;
		background-color: #303133;
		margin-left: 50px;
		width: calc(100vw - 50px);
		height: 100vh;
		> div {
			width: 100%;
			&:hover {
				color: #a4bff6;
			}
			&.actived {
				color: #409eff;
			}
		}
	}

	> div {
		box-sizing: border-box;
		cursor: pointer;
		font-size: 14px;
		color: #909399;
		padding: 20px;

		&:hover {
			color: #303133;
		}

		&.actived {
			border-bottom: 2px solid #409eff;
		}
	}
}
</style>
